import type { ApolloCache } from '@apollo/client';

import {
  ManagerProgressionTaskState,
  StepState,
} from '@sorare/core/src/__generated__/globalTypes';

// Arcade components read the same task as a CareerStep, a separate cache
// entry: flip its state too so they update with the task.
export const markCareerStepClaimed = (
  cache: ApolloCache,
  task: Nullable<{ id: string; aasmState: ManagerProgressionTaskState }>
) => {
  if (task?.aasmState !== ManagerProgressionTaskState.CLAIMED) {
    return;
  }
  const careerStepId = cache.identify({
    __typename: 'CareerStep',
    id: task.id,
  });
  if (!careerStepId) {
    return;
  }
  cache.modify({
    id: careerStepId,
    fields: { state: () => StepState.CLAIMED },
  });
};
